<div class="main-container">
	<mat-toolbar color="accent" class="toolbar-details" mat-scroll-shrink>
		<span class="toolbar-details-title">Contact</span>
	</mat-toolbar>
	<div class="router-container">
		<app-contacts-grid [pageName]="PAGE_NAME.APP_CONTACT"></app-contacts-grid>
	</div>
</div>
